import { API_ROOT } from '../config/ApiConfig';
import { generateRequestHeaders } from '../service/ApiService';
import { RenewalStatus } from '../RecordsPage/models/ResourceModels';

export async function getRenewalStatus(accountId: string, signal?: AbortSignal): Promise<RenewalStatus> {
  let response = await fetch(`${API_ROOT}/renewal/status/${accountId}`, {
    headers: generateRequestHeaders(),
    method: 'GET',
    signal
  })

  // A non-200 response (e.g. 401) may not have a JSON body (an HTML error page, an empty
  // body, a plain-text gateway message). response.json() would reject in that case, which
  // would make this whole function reject instead of resolving with the real httpstatus —
  // so callers (e.g. the 401 session-expiry check) never get a chance to react. A literal
  // JSON `null` body resolves successfully rather than throwing, so it must be coalesced
  // too, or the `data.httpstatus = ...` assignment below throws on a null target.
  let data: any;
  try {
    data = (await response.json()) ?? {};
  } catch {
    data = {};
  }
  data.httpstatus = response.status;
  return adaptRenewalStatusShape(data);
}

// Bridges the currently-live flat response shape ({present, state, origin, completedAt,
// error, updatedAt}) to the target events-array contract ({present, events}) so the
// pill/modal/stepper UI works unmodified against either shape. Synthesizes a single-event
// timeline from the flat fields when no `events` array is present. Remove once the backend
// ships the real per-attempt event history.
function adaptRenewalStatusShape(data: any): RenewalStatus {
  if (Array.isArray(data.events) || !data.state) {
    return data;
  }
  return {
    ...data,
    events: [{
      state: data.state,
      recordedAt: data.updatedAt ?? data.completedAt ?? new Date().toISOString(),
      message: data.error?.message ?? null,
      reasonCode: data.error?.displayCode ?? null
    }]
  };
}

export async function triggerAutoRenewal(body: any): Promise<any> {
  let response = await fetch(`${API_ROOT}/renewal/autorenew`, {
    headers: generateRequestHeaders(),
    method: 'POST',
    body: JSON.stringify(body)
  })

  var data = {httpstatus: 500, data: []};
  data.httpstatus = response.status;
  return data;
}


export async function checkTriggerStatus(body: any): Promise<any> {
  let response = await fetch(`${API_ROOT}/renewal/check`, {
    headers: generateRequestHeaders(),
    method: 'POST',
    body: JSON.stringify(body)
  })

  var data = await response.json()
  data.httpstatus = response.status;
  return data;
}